import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'

// local imports
import './KvkkModal.scss'
import { IContract } from 'types/ContractType'
import ContractService from '../../service/ContractService'
import EmployeeService from '../../service/EmployeeService'
import Button1 from '../ui/Button1'

interface IComponentProps {
  display: boolean
  onHide: () => void
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void
  content: IContract | undefined
}

export default function KvkkModal({ display, onHide, onSubmit, content }: IComponentProps) {
  const { t } = useTranslation()
  const htmlContent = { __html: content?.contractContent || '' }

  const handleApproveContract = (e: React.MouseEvent<HTMLButtonElement>) => {
    console.log('KVKK onaylama başlatılıyor...', content?.id)
    ContractService.SaveContractEmployee({ contractId: content?.id || 1, isApprove: true })
      .then((res) => {
        console.log('KVKK onaylama başarılı:', res)
        getEmployeeSummery()
        onSubmit(e)
      })
      .catch((e) => {
        console.error('KVKK onaylama hatası:', e)
        console.error('Hata detayı:', e.response?.data)
      })
  }

  const getEmployeeSummery = () => {
    console.log('Employee summary güncelleniyor...')
    EmployeeService.getEmployeeSummery(0)
      .then((employeeResponse) => {
        console.log('Employee summary başarıyla güncellendi')
        localStorage.setItem('employee', JSON.stringify(employeeResponse.data))
      })
      .then(() => localStorage.setItem('kvkkDisplay', 'false'))
      .catch((e) => {
        console.error('Employee summary hatası:', e)
      })
  }

  const renderFooter = () => {
    return (
      <div className="row justify-content-center">
        <Button1
          class="button-blue-sm"
          label={t('buttons.approve')}
          onClick={(e) => handleApproveContract(e)}
          disabled={false}
        />
      </div>
    )
  }

  return (
    <Dialog
      id="kvkkModal"
      draggable={false}
      header={t('homepage.kvkk-text')}
      visible={display}
      onHide={onHide}
      breakpoints={{ '960px': '75vw' }}
      style={{ width: '75vw' }}
      footer={renderFooter()}>
      <div className={'kvkk-content'} dangerouslySetInnerHTML={htmlContent} />
    </Dialog>
  )
}
